<template>
  <div class="navigation">
    <div class="item dashboard" :style="getItemStyle('/')" @click="to('/')">
      <i class="fas fa-sliders-h"></i>
      <span>Dashboard</span>
    </div>
	  <div class="item agenda" :style="getItemStyle('/agenda')" @click="to('/agenda')">
      <i class="fas fa-calendar-minus"></i>
      <span>Agenda</span>
    </div>
    <div class="item profile" :style="getItemStyle('/profile')" @click="to('/profile')">
      <i class="far fa-user-circle"></i>
      <span>Profiel</span>
    </div>
    <div class="item fuel" :style="getItemStyle('/fuel')" @click="to('/fuel')">
      <i class="fas fa-gas-pump"></i>
      <span>Verbruik</span>
    </div>
    <div class="item fuel" :style="getItemStyle('/mileage')" @click="to('/mileage')">
      <i class="fas fa-arrow-circle-up"></i>
      <span>KM-stand</span>
    </div>
  </div>
</template>

<script>
export default {
	name: 'Navigation',
	data() {
		return {
			currentLocation: ''
		}
	},
	methods: {
		to(location) {
			if (location !== this.$route.fullPath) {
				this.$router.push(location);
				this.currentLocation = location;
			}
		},
		getItemStyle(path) {
			if (path === this.$route.fullPath) return `color:rgba(0, 161, 173, 1)`;
			else return `color:#b1b1b1`;
		}
	},
	created() {
		this.currentLocation = this.$route.fullPath
	}
}
</script>

<style scoped>

.navigation {
  display: flex;
  justify-content: space-evenly;
}

.item {
  cursor: pointer;

  font-size: 40px;
  margin: 0 10px;

  display: flex;
  flex-direction: column;
  align-items: center;

  color: white;
  transition: .2s;
}

.item:hover {
  color: rgb(170, 170, 170);
  transition: .2s;
}

.item:active {
  color: black;
  transition: .2s;
}

.item > span {
  font-size: 10px;
  margin-top: 3px;
}

</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue